// Detects the dominant color of an image file via a downscaled canvas.
// Skips near-white background and transparent pixels. Resolves null on failure.
export const detectDominantColor = (file) => new Promise((resolve) => {
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    try {
      const size = 64;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, size, size);
      const { data } = ctx.getImageData(0, 0, size, size);
      const buckets = {};
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
        if (a < 128) continue;
        if (Math.min(r, g, b) > 235) continue; // near-white background
        const key = `${r >> 4},${g >> 4},${b >> 4}`;
        buckets[key] = (buckets[key] || 0) + 1;
      }
      const top = Object.entries(buckets).sort((x, y) => y[1] - x[1])[0];
      if (!top) { resolve(null); return; }
      const [rq, gq, bq] = top[0].split(',').map(Number);
      const hex = '#' + [rq, gq, bq].map(v => ((v << 4) + 8).toString(16).padStart(2, '0')).join('');
      resolve(hex);
    } catch {
      resolve(null);
    } finally {
      URL.revokeObjectURL(url);
    }
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
  img.src = url;
});
